import { UploadOutlined } from "@ant-design/icons";
import { Avatar, Button, Col, Divider, Row, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../../../../../../firebase";

const MakeReady = ({ itemId, listId, checkedItems }) => {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {

    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  return (
    <div>
      <h1 style={{ color: "#007db6", fontSize: "30px", textAlign: "center" }}>
        This task will start a make ready workflow when you select it and will
        assign it to you.
      </h1>

      <Row justify="end" gutter={16}>
        <Col>
          <Button>Skip</Button>
        </Col>
        <Col>
          <Button
            type="primary"
            htmlType="submit"
            onClick={handleComplete}
            disabled={isDisabled}
          >
            Complete
          </Button>
        </Col>
      </Row>

      <Divider />

      <Row>
        <Col span={2}>
          <Avatar>KA</Avatar>
        </Col>
        <Col span={22}>
          <TextArea
            style={{
              height: 200,
              resize: "none",
            }}
            placeholder="Write a comment… Type @ to mention other users."
          />
        </Col>
      </Row>
      <Row justify="end" gutter={16}>
        <Col>
          <Upload>
            <Button style={{ marginTop: "10px" }}>
              <UploadOutlined />
            </Button>
          </Upload>
        </Col>
        <Col>
          <Button style={{ marginTop: "10px" }}>Send</Button>
        </Col>{" "}
      </Row>
    </div>
  );
};

export default MakeReady;
